export default {
  status: {
    success: {
      dark1: '#2B774E',
      default: '#44BA79',
    },
    warning: {
      dark1: '#A27632',
      default: '#FCB84F',
    },
    error: {
      dark1: '#99392B',
      default: '#C9331E',
    },
  },
}
